import { atom, useAtom } from 'jotai'
import { useEffect, useState } from 'react'

import { IdentityDto, getCurrentIdentity } from '@/gen/publicApi'

import { authTokenAtom } from './authToken'

export const identityAtom = atom<IdentityDto | undefined>(undefined)

export const useIdentity = () => {
    const [fetched, setFetched] = useState(false)
    const [identity, setIdentity] = useAtom(identityAtom)
    const [authToken, setAuthToken] = useAtom(authTokenAtom)

    useEffect(() => {
        if (authToken && !identity) {
            console.debug('Fetching identity...')
            getCurrentIdentity()
                .then(identity => {
                    setIdentity(identity)
                    setFetched(true)
                })
                .catch(e => {
                    console.error('error getting identity', e)
                    setAuthToken(undefined)
                    setFetched(true)
                })
        }
        if (!authToken || identity) {
            setFetched(true)
        }
    }, [authToken, identity, setAuthToken, setIdentity])

    if (authToken === undefined) {
        // No auth token, no identity
        setIdentity(undefined)
        return { identity: undefined, fetched }
    }

    return { identity, fetched }
}
